var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48011 3.09091H9.80114V10.3139C9.80114 11.0597 9.62536 11.7255 9.27379 12.3114C8.92578 12.8938 8.43395 13.3537 7.7983 13.6911C7.16264 14.0249 6.4169 14.1918 5.56108 14.1918C4.70526 14.1918 3.95952 14.0249 3.32386 13.6911C2.68821 13.3537 2.1946 12.8938 1.84304 12.3114C1.49503 11.7255 1.32102 11.0597 1.32102 10.3139V3.09091H2.64205V10.2074C2.64205 10.7401 2.75923 11.2141 2.99361 11.6296C3.22798 12.0415 3.56179 12.3665 3.99503 12.6044C4.43182 12.8388 4.95384 12.956 5.56108 12.956C6.16832 12.956 6.69034 12.8388 7.12713 12.6044C7.56392 12.3665 7.89773 12.0415 8.12855 11.6296C8.36293 11.2141 8.48011 10.7401 8.48011 10.2074V3.09091Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16H1V17H11V16Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.fcf3024a825ba1c83e6b0e3c2fa42c54.svg";
export { ForwardRef as ReactComponent };